<template>
  <el-date-picker class="range-picker" v-model="dateArr" :type="month ? 'monthrange' : 'daterange'" range-separator="~"
    :start-placeholder="month ? '开始月份' : '开始日期'" :end-placeholder="month ? '结束月份' : '结束日期'" value-format="yyyy-MM-dd"
    :picker-options="options" @change="onChange" :clearable='clearable'></el-date-picker>
</template>
<script>
export default {
  props: {
    date: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    month: {
      type: Boolean,
      default: false,
    },
    sDate: {
      type: String,
      default: "",
    },
    eDate: {
      type: String,
      default: "",
    },
  },
  watch: {
    date() {
      this.dateArr = [];
      this.date.forEach((x) => {
        if (x) this.dateArr.push(x);
      });
    },
  },
  mounted() {
    this.date.forEach((x) => {
      if (x) this.dateArr.push(x);
    });
  },
  data() {
    return {
      dateArr: [],
      options: {
        disabledDate: this.disabledDate,
      },
    };
  },
  methods: {
    disabledDate(value) {
      if (this.sDate || this.eDate) {
        value = this.$commonJs.toDateString(value);
        var start = this.sDate ? value > this.sDate : false;
        var end = this.eDate ? value < this.eDate : false;
        return start || end;
      } else {
        return false;
      }
    },
    onChange() {
      console.log("change", this.dateArr);
      var data = { Start: null, End: null };
      if (this.dateArr) {
        data.Start = this.dateArr[0];
        if (this.month) {
          var date = this.$dayjs(this.dateArr[1]);
          data.End = date.endOf("month").format("YYYY-MM-DD");
        } else {
          data.End = this.dateArr[1];
        }
      }
      this.$emit("change", data);
    },
    clear() {
      this.dateArr = [];
    },
  },
};
</script>
<style lang="scss">
.range-picker {
  width: 180px !important;
  padding: 3px 1px 3px 10px !important;

  .el-range__icon {
    width: 0;
    margin: 0;
  }
}
</style>